import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import type { KeywordSearchHistory } from './history'
import {
  getKeywordSearchHistory,
  DEFAULT_KEYWORD_SEARCH_HISTORY,
  STORAGE_KEY,
} from './storage'

const MAX_HISTORY_COUNT = 10

type KeywordSearchHistoryAction = {
  addSearchHistory: (history: KeywordSearchHistory) => void
  deleteSearchHistory: (id: string) => void
  clearSearchHistory: () => void
}

type KeywordSearchHistoryState = {
  searchHistory: KeywordSearchHistory[]
  checkSearchHistoryExist: () => boolean
  actions: KeywordSearchHistoryAction
}

export const useKeywordSearchHistoryStore = create<KeywordSearchHistoryState>()(
  persist(
    (set, get) => ({
      searchHistory: getKeywordSearchHistory(),
      checkSearchHistoryExist: () => {
        const currentHistory = get().searchHistory

        return currentHistory.length > 0
      },
      actions: {
        addSearchHistory: (newHistory: KeywordSearchHistory) => {
          const currentHistory = get().searchHistory

          const sameHistoryIndex = currentHistory.findIndex(
            history =>
              history.keyword === newHistory.keyword &&
              history.startDate === newHistory.startDate &&
              history.endDate === newHistory.endDate,
          )

          if (sameHistoryIndex !== -1) {
            currentHistory.splice(sameHistoryIndex, 1)
          }

          if (currentHistory.length >= MAX_HISTORY_COUNT) {
            currentHistory.pop()
          }

          set({ searchHistory: [newHistory, ...currentHistory] })
        },
        deleteSearchHistory: (id: string) => {
          set({
            searchHistory: get().searchHistory.filter(
              history => history.id !== id,
            ),
          })
        },
        clearSearchHistory: () => {
          set({ searchHistory: DEFAULT_KEYWORD_SEARCH_HISTORY })
        },
      },
    }),
    {
      name: STORAGE_KEY,
      partialize: state => ({
        searchHistory: state.searchHistory,
      }),
    },
  ),
)
